import styled from "styled-components";

export const Pill = styled.div`
  height: 64px;
  /* min-width: 120px; */
  background-color: ${({ theme }) => theme.colors.hotPink};
  border-radius: 32px;
  pointer-events: none;
  display: flex;
  /* justify-content: center; */
  align-items: center;
  color: ${({ theme }) => theme.colors.white};
  white-space: nowrap;
  word-break: normal;
  padding: 0 32px;
  font-weight: 700;
  overflow: hidden;
  /* position: relative; */

  svg {
    position: absolute;
    width: 32px;
    height: 32px;
    left: 16px;
    top: 16px;
  }
`;
